import { createSlice } from "@reduxjs/toolkit";
import {
  getConfirmacionStatusThunk,
  getCurrentConfirmacionThunk,
  sendConfirmacionAnswerThunk,
  getMisTalentosThunk,
  getConfirmacionesCompletadasThunk,
  getConfirmacionSummaryThunk,
} from "./confirmacion.thunks";

const initialState = {
  // Estado de las confirmaciones
  status: null, // { todas_completadas: false, talento_nombre: "..." }
  
  // Pregunta actual
  currentQuestion: null,
  
  // Mis talentos óptimos
  talentosOptimos: [],
  
  // Talentos ya confirmados
  confirmaciones: [],
  
  // Resumen final de confirmaciones
  summary: null,
  
  // Frases seleccionadas en la pregunta actual
  selectedFrases: [],
  
  // Estados de carga
  loading: false,
  statusLoading: false,
  talentosLoading: false,
  confirmacionesLoading: false,
  summaryLoading: false,
  
  // Error
  error: null,
};

const confirmacionSlice = createSlice({
  name: "confirmacion",
  initialState,
  reducers: {
    toggleFrase: (state, action) => {
      const fraseId = action.payload;
      const index = state.selectedFrases.indexOf(fraseId);
      
      if (index > -1) {
        // Si ya está seleccionada, la quitamos
        state.selectedFrases.splice(index, 1);
      } else {
        // Si no está, la agregamos
        state.selectedFrases.push(fraseId);
      }
    },
    clearSelectedFrases: (state) => {
      state.selectedFrases = [];
    },
    resetConfirmacionState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET STATUS
      .addCase(getConfirmacionStatusThunk.pending, (state) => {
        state.statusLoading = true;
        state.error = null;
      })
      .addCase(getConfirmacionStatusThunk.fulfilled, (state, action) => {
        state.statusLoading = false;
        state.status = action.payload;
      })
      .addCase(getConfirmacionStatusThunk.rejected, (state, action) => {
        state.statusLoading = false;
        state.error = action.payload;
      })
      
      // GET CURRENT QUESTION
      .addCase(getCurrentConfirmacionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCurrentConfirmacionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.currentQuestion = action.payload;
        // Limpiar selección al cambiar de pregunta
        state.selectedFrases = [];
      })
      .addCase(getCurrentConfirmacionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // SEND ANSWER
      .addCase(sendConfirmacionAnswerThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendConfirmacionAnswerThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendConfirmacionAnswerThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // GET MIS TALENTOS
      .addCase(getMisTalentosThunk.pending, (state) => {
        state.talentosLoading = true;
        state.error = null;
      })
      .addCase(getMisTalentosThunk.fulfilled, (state, action) => {
        state.talentosLoading = false;
        state.talentosOptimos = action.payload.talentos_optimos || [];
      })
      .addCase(getMisTalentosThunk.rejected, (state, action) => {
        state.talentosLoading = false;
        state.error = action.payload;
      })
      
      // GET CONFIRMACIONES COMPLETADAS
      .addCase(getConfirmacionesCompletadasThunk.pending, (state) => {
        state.confirmacionesLoading = true;
        state.error = null;
      })
      .addCase(getConfirmacionesCompletadasThunk.fulfilled, (state, action) => {
        state.confirmacionesLoading = false;
        state.confirmaciones = action.payload.confirmaciones || [];
      })
      .addCase(getConfirmacionesCompletadasThunk.rejected, (state, action) => {
        state.confirmacionesLoading = false;
        state.error = action.payload;
      })
      
      // GET SUMMARY
      .addCase(getConfirmacionSummaryThunk.pending, (state) => {
        state.summaryLoading = true;
        state.error = null;
      })
      .addCase(getConfirmacionSummaryThunk.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summary = action.payload;
      })
      .addCase(getConfirmacionSummaryThunk.rejected, (state, action) => {
        state.summaryLoading = false;
        state.error = action.payload;
      });
  },
});

export const { toggleFrase, clearSelectedFrases, resetConfirmacionState } =
  confirmacionSlice.actions;

export default confirmacionSlice.reducer;
